// Central category → emoji + accent color map. Used across Register, Budgets,
// TransactionForm, Dashboard so category rows have a consistent visual identity.
// Keep this list in sync with the backend `_detect_category` map and the
// TransactionForm categories dropdown.

export const CATEGORY_META = {
  Food: { emoji: "🍔", color: "#fdecc8" },
  Transport: { emoji: "🚗", color: "#c8e7fd" },
  Shopping: { emoji: "🛍️", color: "#f4c2c2" },
  Bills: { emoji: "🧾", color: "#e2d5f7" },
  Subscriptions: { emoji: "📺", color: "#d9d4f1" },
  Entertainment: { emoji: "🎮", color: "#ffd6a5" },
  Gifts: { emoji: "🎁", color: "#ffc8dd" },
  Health: { emoji: "💊", color: "#b5e4ca" },
  School: { emoji: "📚", color: "#fdd692" },
  Income: { emoji: "💰", color: "#b5e4ca" },
  Transfer: { emoji: "🔁", color: "#e0e0e0" },
  Other: { emoji: "📌", color: "#eeeeee" },
  Uncategorized: { emoji: "📌", color: "#eeeeee" },
};

export function catMeta(name) {
  if (!name) return CATEGORY_META.Uncategorized;
  return CATEGORY_META[name] || { emoji: "📌", color: "#eeeeee" };
}

/** Small inline pill: `[🍔 Food]`. Import and drop wherever a category shows up. */
export function CategoryPill({ category, size = "sm" }) {
  const m = catMeta(category);
  const py = size === "xs" ? "py-0" : "py-0.5";
  const px = size === "xs" ? "px-1.5" : "px-2";
  const txt = size === "xs" ? "text-[10px]" : "text-[11px]";
  return (
    <span
      data-testid={`cat-pill-${(category || "Uncategorized").toLowerCase()}`}
      className={`inline-flex items-center gap-1 rounded-full border-2 border-[#1a1a1a] font-bold ${txt} ${px} ${py}`}
      style={{ background: m.color }}
    >
      <span aria-hidden>{m.emoji}</span>
      <span>{category || "Uncategorized"}</span>
    </span>
  );
}
